<template>
    <div class="container">
        <div class="field has-addons m-b-20" v-if="!model.unknown_week_days">
            <p class="control" v-for="day of model.days">
                <a class="button is-size-7-mobile is-size-5-desktop"
                   :class="{ 'is-link': day.enabled }"
                   @click.prevent="toggleWeekDay(day)">
                    <span>{{ day.short }}</span>
                </a>
            </p>
        </div>
        <div class="field p-l-20">
            <Checkbox type="checkbox" name="unknown_week_days" v-model="model.unknown_week_days" label="Aún no lo tengo claro"></Checkbox>
        </div>
    </div>
</template>

<script>
import stepMixin from '../mixins/step';
import Checkbox from './Checkbox';

export default {
  name: 'funnel-paso-3',
  components: {
    Checkbox
  },
  mixins: [
    stepMixin
  ],
  methods: {
    toggleWeekDay: function (day) {
      var index = this.model.days.indexOf(day);

      day.enabled = !day.enabled;

      var slots = this.model.schedule_multiple[index];

      if (day.enabled) {
        if (!slots.length) {
          slots.push({
            start: null,
            end: null
          });
        }
      } else {
        slots.splice(0, slots.length);
      }
    }
  }
}
</script>
